import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CustomBreadcrumb from '../../../components/base/CustomBreadcrumb';
import CustomListComponent from '../../../components/base/CustomListComponent';
import { createAction } from '../../../utils';
import ContentSections from '../../../components/base/ContentSections';
import { APIStatus, LanguageConfig } from '../../../config/CustomEnums';
import Loading from '../../../components/base/Loading';
import AuthButton from '../../../components/base/AuthButton';
import { PermissionCodes } from '../../../config/PermissionCodes';
import MembershipInfoCard from '../../../components/customer/MembershipInfoCard';
import { Button } from 'react-bootstrap';


const AfcAccountBindingRecordDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  const { apiStatus, afcAccountBindingRecord } = useSelector((state) => ({
    afcAccountBindingRecord: state.afcAccountBindingRecords.afcAccountBindingRecord,
    apiStatus: state.afcAccountBindingRecords.apiStatus
  }));

  console.log('@28', afcAccountBindingRecord)
  const tabs = [
    {
      name: 'Detail',
      content: (
        <div className="scroll-container-common">
          <ContentSections
            sections={[
              <MembershipInfoCard
                title={''}
                data={afcAccountBindingRecord ? afcAccountBindingRecord : {}}
                fields={[
                  [{ title: 'First Name', field: 'firstName' }],
                  [{ title: 'Last Name', field: 'lastName' }],
                  [{ title: 'Membership ID', field: 'membershipId' }],
                  [{ title: 'Status', field: 'status' }],
                  [{ title: 'Creation Date', field: 'creationDate' }],
                ]}
                // extraDataFields={{ numberOfcustomers: customerTotalCount }}
              />,
            ]}
            hidePreview={true}
            // sectionStyle="detail-info-section-item"
          />
        </div>
      ),
    },
  ];

  const buttons = [
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  useEffect(() => {
    const recordId = params.id;
    if (recordId) {
      dispatch(
        createAction('afcAccountBindingRecords/getOneAfcAccountBindingRecord')({ id: recordId }),
      );
    }
    return () => {
      dispatch({ type: 'afcAccountBindingRecords/clearData' });
    };
  }, []);

  return (
    <div className="campaign-category-detail">
      <CustomListComponent
        caution={{
          detail: '',
          title: afcAccountBindingRecord?.pk,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={afcAccountBindingRecord?.pk} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
};

export default AfcAccountBindingRecordDetail;
